import { useState, useEffect } from "react";
import UserTopbar from "../UserTopbar";
import UserSection from "../../Services/User/UserLogin";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { handleApiError } from "../../Helpers/handleApiError ";
import Lottie from "lottie-react";
import animationData from "../../animations/loader_animation0.json";
import { useOutletContext } from "react-router-dom";

import Loader from "../utils/Loader";
import { Skeleton } from "@mui/material";
const UserHelpDesk = () => {
  const navigate = useNavigate();
  const { isSidebarOpen } = useOutletContext();
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    categoery: "login_issue",
    text: "",
  });
  const myStyles = {
    position: "absolute",
    marginTop: "-58px",
    marginLeft: "700px",
    border: "1px solid",
    padding: "10px",
    width: "300px",
  };
  const handleSubmit = async () => {
    try {
      setLoading(true);
      const response = await UserSection.saveSuggestion(formData);
      if (response.status) {
        helpDeskList();

        Swal.fire({
          icon: "success",
          title: "success",
          text: "Ticket raise  successfully",
          timer: 3000,
        });

        setFormData({ categoery: "login_issue", text: "" });
        document.getElementById("categoery").value = "";

        setLoading(false);
        navigate("/user/help-desk");
      }
    } catch (error) {
      // console.log(error);
      setLoading(false);
      handleApiError(error, "Failed to fetch data. Please try again later.");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const helpDeskList = async () => {
    try {
      setLoading(true);
      const response = await UserSection.helpDeskList();
      if (response && Array.isArray(response.data)) {
        setData(response.data);
      } else {
        setData([]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
      handleApiError(error, "Failed to fetch data. Please try again later.");
    }
  };
  useEffect(() => {
    helpDeskList();
  }, []);
  return (
    <>
      <UserTopbar heading={`Help-Desk`} sidebar={isSidebarOpen} />
      
      <div className="mt-8 px-6 max-w-7xl mx-auto h-[calc(100vh-100px)] overflow-y-auto custom-scrollbar pb-10">
        {/* Light Glassmorphism Container for Form */}
        <div className="bg-white/60 backdrop-blur-md border border-white rounded-2xl shadow-lg p-6 mb-8 text-gray-800 relative overflow-hidden">
          {/* Subtle gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-br from-white/40 to-transparent pointer-events-none" />
          
          <h2 className="text-xl font-bold mb-6 flex items-center gap-2 relative z-10">
            <span className="text-[#ff7b00]">Raise</span> a Ticket
          </h2>
          
          <form className="space-y-6 relative z-10" action="#">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              
              <div className="flex flex-col gap-2">
                <label htmlFor="categoery" className="text-sm font-medium tracking-wide text-gray-700">
                  Category
                </label>
                <select
                  id="categoery"
                  name="categoery"
                  value={formData.categoery}
                  onChange={handleChange}
                  className="bg-white/80 border border-gray-300 text-gray-800 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#ff7b00]/50 focus:border-[#ff7b00] transition-all shadow-sm appearance-none"
                >
                  <option value="">Select Category</option>
                  <option value="login_issue">Login issue</option>
                  <option value="change_password">Change password</option>
                  <option value="Quotation_related_issues">Quotation related issues</option>
                  <option value="view_project_related_issue">View project related issue</option>
                  <option value="summary_related_issue">Summary related issue</option>
                  <option value="suggestions">Suggestions</option>
                  <option value="Others">Others</option>
                </select>
              </div>

              <div className="flex flex-col justify-center bg-white/50 border border-white rounded-xl p-4 shadow-sm">
                <div className="flex items-center gap-3 mb-2">
                  <div className="bg-orange-100 p-2 rounded-lg text-[#ff7b00]">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" /></svg>
                  </div>
                  <span className="text-sm font-medium tracking-wide text-gray-800">Phone: <span className="text-gray-600">9625650376</span></span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="bg-orange-100 p-2 rounded-lg text-[#ff7b00]">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" /><path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" /></svg>
                  </div>
                  <span className="text-sm font-medium tracking-wide text-gray-800">Email: <span className="text-gray-600">helpdesk.ruminate@gmail.com</span></span>
                </div>
              </div>

            </div>

            <div className="flex flex-col gap-2">
              <label htmlFor="text" className="text-sm font-medium tracking-wide text-gray-700">
                Message
              </label>
              <textarea
                rows="4"
                value={formData.text}
                onChange={handleChange}
                id="text"
                name="text"
                type="text"
                required
                className="bg-white/80 border border-gray-300 text-gray-800 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#ff7b00]/50 focus:border-[#ff7b00] transition-all shadow-sm w-full placeholder:text-gray-400"
                placeholder="Describe your issue in detail..."
              />
            </div>

            <div className="flex justify-end">
              <button
                onClick={handleSubmit}
                type="button"
                disabled={loading}
                className="bg-[#ff7b00] hover:bg-[#e66a00] text-white px-8 py-2.5 rounded-lg font-semibold tracking-wide shadow-md hover:shadow-lg transition-all active:scale-95 disabled:opacity-70 flex items-center gap-2"
              >
                {loading ? (
                   <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z" clipRule="evenodd" /></svg>
                )}
                Submit Ticket
              </button>
            </div>
          </form>
        </div>

        {/* Light Glassmorphism Container for Table */}
        <div className="bg-white/60 backdrop-blur-md border border-white rounded-2xl shadow-lg overflow-hidden mb-12">
          {Array.isArray(data) ? (
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-white/50 border-b border-white">
                    <th className="px-6 py-4 text-sm font-bold text-gray-800 uppercase tracking-wider">Ticket ID</th>
                    <th className="px-6 py-4 text-sm font-bold text-gray-800 uppercase tracking-wider">Category</th>
                    <th className="px-6 py-4 text-sm font-bold text-gray-800 uppercase tracking-wider">Message</th>
                    <th className="px-6 py-4 text-sm font-bold text-gray-800 uppercase tracking-wider">Status</th>
                    <th className="px-6 py-4 text-sm font-bold text-gray-800 uppercase tracking-wider">Last Updated</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-white/50 text-gray-700 bg-white/40">
                  {data.map((item, index) => (
                    <tr key={index} className="hover:bg-white/60 transition-colors">
                      <td className="px-6 py-4 font-medium whitespace-nowrap">#{item.id}</td>
                      <td className="px-6 py-4 text-sm capitalize whitespace-nowrap">
                        <span className="bg-white/80 px-3 py-1 rounded-full border border-gray-200 shadow-sm">{item.categoery?.replace(/_/g, ' ')}</span>
                      </td>
                      <td className="px-6 py-4 max-w-xs truncate">{item.suggestion}</td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`px-3 py-1 rounded-full text-xs font-semibold ${item.status?.toLowerCase() === 'resolved' ? 'bg-green-100 text-green-700 border border-green-200' : 'bg-yellow-100 text-yellow-700 border border-yellow-200'}`}>
                          {item.status || 'Pending'}
                        </span>
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-600 whitespace-nowrap">
                        {item.updated_at ? new Date(item.updated_at).toLocaleDateString("en-GB", { day: '2-digit', month: 'short', year: 'numeric' }) : ""}
                      </td>
                    </tr>
                  ))}
                  {data.length === 0 && (
                    <tr>
                      <td colSpan="5" className="px-6 py-12 text-center text-gray-500 italic">No tickets found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-white/50 border-b border-white">
                    <th className="px-6 py-4 text-sm font-bold text-gray-800 uppercase tracking-wider">Ticket ID</th>
                    <th className="px-6 py-4 text-sm font-bold text-gray-800 uppercase tracking-wider">Category</th>
                    <th className="px-6 py-4 text-sm font-bold text-gray-800 uppercase tracking-wider">Message</th>
                    <th className="px-6 py-4 text-sm font-bold text-gray-800 uppercase tracking-wider">Status</th>
                    <th className="px-6 py-4 text-sm font-bold text-gray-800 uppercase tracking-wider">Last Updated</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-white/50 bg-white/40">
                  {[1, 2, 3, 4, 5].map((index) => (
                    <tr key={index} className="transition-colors">
                      <td className="px-6 py-4"><Skeleton variant="text" width={60} /></td>
                      <td className="px-6 py-4"><Skeleton variant="rounded" width={100} height={28} sx={{ borderRadius: '9999px' }} /></td>
                      <td className="px-6 py-4"><Skeleton variant="text" width="100%" /></td>
                      <td className="px-6 py-4"><Skeleton variant="rounded" width={80} height={24} sx={{ borderRadius: '9999px' }} /></td>
                      <td className="px-6 py-4"><Skeleton variant="text" width={80} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default UserHelpDesk;
